import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'shop',
    serviceName: 'graphql',
    query: gql`
      query shop($ids: [String], $for_admin: Int) {
        shop(ids: $ids, for_admin: $for_admin) {
          data {
            work_times
          }
        }
      }
    `,
  },
  update: {
    name: 'updateShop',
    serviceName: 'shopadmin',
    query: gql`
      mutation updateShop($ids: [String]!, $work_times: String) {
        updateShop(ids: $ids, work_times: $work_times) {
          messages
        }
      }
    `,
  },
};

export default schema;
